import { render, staticRenderFns } from "./SelectCollaborateur.vue?vue&type=template&id=94bb94ec&"
import script from "./SelectCollaborateur.vue?vue&type=script&lang=js&"
export * from "./SelectCollaborateur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports